import { StyledContainer } from './style';

function Container(props){
  return(
    <StyledContainer>{props.children}</StyledContainer>
  )
}

export default Container;
